import { useContext } from 'react';
import { useQueryClient } from 'react-query';

import { SilentContext } from './Silent';

export const useSilentInvalidateQueries = () => {
  const queryClient = useQueryClient();
  const { addQuery, resetQuery } = useContext(SilentContext);

  return async queryKey => {
    addQuery(queryKey);
    await queryClient.invalidateQueries(queryKey, {
      fetching: false,
    });
    resetQuery(queryKey);
  };
};
